import React, { useState, useEffect } from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { useTranslation } from 'react-i18next';

const ShowResultsButton = ({ isVisible, onShowResults }) => {
  const { results } = useInstantSearch();
  const [showButton, setShowButton] = useState(true);
  const { t } = useTranslation('common');

  useEffect(() => {
    const handleScroll = () => {
      const resultsElement = document.getElementById('search-results');
      if (!resultsElement) return;

      const rect = resultsElement.getBoundingClientRect();
      const isOverResults = rect.top <= window.innerHeight;
      setShowButton(!isOverResults);
    };

    if (isVisible) {
      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Initial check
    }

    return () => window.removeEventListener('scroll', handleScroll);
  }, [isVisible]);

  if (!isVisible || !showButton) return null;

  return (
      <button
          onClick={onShowResults}
          className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 inline-flex items-center gap-x-2 rounded-full bg-sky-600 px-6 py-3 text-sm font-semibold text-white shadow-lg hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600"
      >
        {t('listings.showResults', {
          count: results?.nbHits || 0,
          defaultValue: 'Show {{count}} estates'
        })}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-4 h-4"
        >
          <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
          />
        </svg>
      </button>
  );
};

export default ShowResultsButton;